export default {
    // 賬號在線狀態才可進行儲值，需要退款時請聯系客訴後臺進行反饋，否則將被系統自動封號
    tips: "",
    userAgreement: "用戶協議",
    privacyAgreement: "隱私政策",
    company: "趣玩貓互動娛樂科技有限公司",
    email: "信箱：amazingcatgames@gmail.com",
    methods: {
        logoutMsg: "是否退出登入",
        tips: "提示",
        confirm: "確認",
        cancellation: "取消"
    }
}